import {useContext, useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {quickSearch} from "../../../api/catalog";
import {useDebounce} from "@uidotdev/usehooks";
import {SearchResponseItemInterface} from "../../../interfaces/catalog/SearchRespponseItemInterface";
import {Link, useLocation, useNavigate} from "react-router-dom";
import useLocalStorage from "../../../utils/useLocalStorage";
import {LOCAL_STORAGE_KEY_SEARCH_STRING} from "../../../Config";
import {GlobalContext, ReducerActionType} from "../../../GlobalReducer";
import {ReducerStateInterface} from "../../../interfaces/core/ReducerStateInterface";

export default function SearchString({isSearchOpen}: { isSearchOpen: boolean }) {
    const [searchString, setSearchString] = useState<string >('');
    const debouncedSearchString = useDebounce(searchString, 500);
    const navigate = useNavigate();
    const location = useLocation();

    const [, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data, } = useQuery({
        queryKey: [debouncedSearchString],
        queryFn: () => quickSearch(debouncedSearchString || ''),
        enabled: !!debouncedSearchString,
    })

    useEffect(() => {
        setSearchString('')
    }, [location]);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if(!searchString){
            return;
        }

        setItems(LOCAL_STORAGE_KEY_SEARCH_STRING, [searchString]);
        dispatch({type: ReducerActionType.SET_PARAM, paramName: 'searchString',  payload: searchString})
        navigate('/search');
    };

    const {setItems} = useLocalStorage()

    useEffect(() => {
        if(debouncedSearchString){
            setItems(LOCAL_STORAGE_KEY_SEARCH_STRING, [debouncedSearchString]);
        }
    }, [debouncedSearchString]);

    return (<form className={'d-flex header__search w-md-auto ' + (isSearchOpen && '_open')} onSubmit={handleSubmit}>
        <input className="w-100" type="text" name="search" placeholder="Что вы хотите найти?" value={searchString || ''}
               onChange={(event) => setSearchString(event.target.value)}/>
        {data && data.length > 0 && <div className="header__search-dropdown">
            <ul>
                {data?.map((item: SearchResponseItemInterface) => <li><Link to={item.href}
                                                                            onClick={() => setSearchString('')}
                                                                            dangerouslySetInnerHTML={{__html: item.name}}></Link>
                </li>)}
            </ul>
        </div>}

        <button type="submit" className="header__btn-big header__search-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.4805 15.875C15.3358 15.875 18.4611 12.657 18.4611 8.6875C18.4611 4.71795 15.3358 1.5 11.4805 1.5C7.62529 1.5 4.5 4.71795 4.5 8.6875C4.5 12.657 7.62529 15.875 11.4805 15.875Z"
                    stroke="#292929" strokeWidth="2"/>
                <path d="M9.61584 22.5261L13.3452 15.875" stroke="#292929" strokeWidth="2"/>
            </svg>
        </button>
    </form>)
}